import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputList from "../components/Form/UiInputList";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputTextarea from "../components/Form/UiInputTextarea";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

const tipoList = [
    { id: 'texto', title: 'Texto' },
    { id: 'numero', title: 'Número' },
    { id: 'data', title: 'Data' },
    { id: 'selecao', title: 'Seleção' },
    { id: 'booleano', title: 'Sim/Não' },
    { id: 'foto', title: 'Foto' },
    { id: 'arquivo', title: 'Arquivo' },
    { id: 'assinatura', title: 'Assinatura' },
];

/**
 * Um campo do template. Chega pela ação "Campos" do grid de templates.
 *
 * Template publicado não tem campo alterado: o servidor recusa e diz para criar uma
 * versão nova. A tela avisa antes, para o operador não digitar em vão.
 */
export default function CampoForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { tipo: 'texto', ordem: 0, obrigatorio: false }
    });
    const { handleSubmit, reset, watch } = methods;

    const publicado = !!watch('templatePublicado');
    const publicadoEm = watch('publicadoEm');

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    {publicado && (
                        <div className="alert alert-warning">
                            <strong>Template publicado{typeof publicadoEm === 'string' ? ` em ${publicadoEm}` : ''}.</strong>{' '}
                            Este campo não pode ser alterado: as tarefas em andamento apontam para esta versão.
                            Use <strong>Nova versão</strong> no grid de templates e edite os campos da nova.
                        </div>
                    )}

                    <div className="row">
                        <UiInputSuggest size={12} name="template" router="tartemplate" idField="id" titleField="nome" label="Template"/>
                        <UiInputText size={5} name="chave" label="Chave" placeholder="aterramento"/>
                        <UiInputText size={7} name="titulo" label="Título" placeholder="Aterramento executado"/>
                        <UiInputList size={5} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo"/>
                        <UiInputNumberInteger size={3} name="ordem" label="Ordem"/>
                        {/* Um booleano só: com um único momento de encerramento, a
                            obrigatoriedade por etapa perdeu o que distinguir. */}
                        <UiInputCheckbox size={4} name="obrigatorio" label="Obrigatório para concluir"/>
                        <UiInputText size={12} name="ajuda" label="Ajuda para quem preenche"/>
                        <UiInputTextarea size={12} name="opcoes" label="Opções (uma por linha, só para o tipo Seleção)" rows={4}/>
                        <UiInputText size={12} name="validacao" label="Validação (JSON)" placeholder={'{"min":1}'}/>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
